module.exports = __webpack_public_path__ + "static/media/tt.7140ffa0.svg";